module.exports = __webpack_public_path__ + "src/assets/img/bg2.60342f8c.jpg";